export type LoginCompletionMethod = "magic-link" | "sso";

export function getSafeLoginReturnTo(search: string) {
  const candidate = new URLSearchParams(search).get("returnTo");
  if (!candidate || !candidate.startsWith("/") || candidate.startsWith("//")) {
    return null;
  }

  try {
    const parsed = new URL(candidate, "https://hawk.local");
    if (parsed.origin !== "https://hawk.local") {
      return null;
    }
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return null;
  }
}

export function buildLoginCompletionPath(
  method: LoginCompletionMethod,
  returnTo: string | null,
) {
  const params = new URLSearchParams({ authComplete: method });
  if (returnTo) {
    params.set("returnTo", returnTo);
  }
  return `/login?${params.toString()}`;
}

export function buildLoginErrorPath(
  method: LoginCompletionMethod,
  returnTo: string | null,
) {
  const params = new URLSearchParams({ authError: method });
  if (returnTo) {
    params.set("returnTo", returnTo);
  }
  return `/login?${params.toString()}`;
}
